import type { ContentLibraryItem as ApiContentLibraryItem } from '@/services/api'
import type { ContentItem } from '@/types'

function toIsoString(value: unknown): string {
  if (typeof value === 'string' && value.trim()) return value
  if (value instanceof Date) return value.toISOString()
  return new Date().toISOString()
}

function toStringArray(value: unknown): string[] {
  if (!Array.isArray(value)) return []
  return value.filter((v): v is string => typeof v === 'string')
}

function toStringIdArray(value: unknown): string[] {
  if (!Array.isArray(value)) return []
  return value
    .map((v) => (typeof v === 'string' ? v : v != null ? String(v) : ''))
    .filter((v): v is string => typeof v === 'string' && v.trim().length > 0)
}

export class LibraryMapper {
  static toContentItem(apiItem: ApiContentLibraryItem): ContentItem {
    const platforms: Record<string, any> = {}
    for (const [platformKey, platformData] of Object.entries(apiItem.platforms || {})) {
      const pd: any = platformData as any
      platforms[platformKey] = {
        content: pd.content ?? '',
        markdownSource: typeof pd.markdown_source === 'string' ? pd.markdown_source : undefined,
        score: typeof pd.score === 'number' ? pd.score : 0,
        geoBreakdown: pd.geo_breakdown,
        publishedUrl: typeof pd.published_url === 'string' ? pd.published_url : undefined,
      }
    }

    return {
      id: String(apiItem.id),
      title: apiItem.title,
      targetQuery: apiItem.target_query || '',
      targetQueries: toStringArray(apiItem.target_queries),
      promptIds: toStringIdArray(apiItem.prompt_ids),
      status: apiItem.status,
      generationStatus: apiItem.generation_status,
      platforms,
      citations: apiItem.citations ?? undefined,
      hasAttribution: apiItem.has_attribution ?? undefined,
      traffic: apiItem.traffic ?? undefined,
      activeSkills: toStringArray((apiItem as any).active_skills),
      createdAt: toIsoString(apiItem.created_at),
      publishedAt: apiItem.published_at || undefined,
      scheduledPublishAt: apiItem.scheduled_publish_at || undefined,
    }
  }

  static toContentItems(apiItems: ApiContentLibraryItem[]): ContentItem[] {
    return apiItems.map((item) => LibraryMapper.toContentItem(item))
  }
}

